import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <div className={`rounded-xl border border-line bg-white shadow-card ${className}`} data-id="element-420" data-mp="3ar695qn1xe3">{children}</div>;
}
interface SectionHeaderProps {
  naslov: string;
  opis?: string;
  akcija?: React.ReactNode;
  className?: string;
}
export function SectionHeader({
  naslov,
  opis,
  akcija,
  className = ''
}: SectionHeaderProps) {
  return <div className={`flex items-start justify-between gap-4 ${className}`} data-id="element-421" data-mp="m336nmxqeoll">
      <div data-id="element-422" data-mp="m5fuggq67t6k">
        <h2 className="text-base font-semibold text-ink" data-id="element-423" data-mp="r2g411m8be2f">{naslov}</h2>
        {opis && <p className="mt-0.5 text-sm text-ink-muted" data-id="element-424" data-mp="r0d3vord44jz">{opis}</p>}
      </div>
      {akcija}
    </div>;
}